var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMillustrationsCode = function SvgMillustrationsCode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.04,
    d: "M0 2a2 2 0 0 1 2-2h52a2 2 0 0 1 2 2v36a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 23,
    x: 8.5,
    y: 8.5,
    fill: "#fff",
    stroke: "#CCCCD9",
    rx: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#A39FEF",
    d: "M21.293 24.707a1 1 0 0 0 1.414-1.414zM18 20l-.707-.707a1 1 0 0 0 0 1.414zm4.707-3.293a1 1 0 0 0-1.414-1.414zm0 6.586-4-4-1.414 1.414 4 4zm-4-2.586 4-4-1.414-1.414-4 4zM30.936 16.351a1 1 0 0 0-1.872-.702zm-4.872 7.298a1 1 0 0 0 1.872.702zm3-8-3 8 1.872.702 3-8zM35.707 15.293a1 1 0 0 0-1.414 1.414zM39 20l.707.707a1 1 0 0 0 0-1.414zm-4.707 3.293a1 1 0 0 0 1.414 1.414zm0-6.586 4 4 1.414-1.414-4-4zm4 2.586-4 4 1.414 1.414 4-4z"
  })));
};
export default SvgMillustrationsCode;